export default __webpack_public_path__ + "static/media/BulishUnicorn-logo.cca1e671.svg";